define('rebrush/components/product/view/addtocart/related',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'gigaset/spinner',
], function(
    $,
    _,
    Component,
    BEM,
    Spinner
) {
    return Component.create({
        miniCart: null,
        addToCartPopup: null,
        destructorCallbacks: null,

        constructor: function() {
            // this.onClickCallback = _.bind(this._onClick, this);
            // this.linkSelector = '.' + BEM.buildBlockClassname('review-summary') + ' a';
            this.destructorCallbacks = [];
        },

        init: function() {
            var self = this;
            var addToCartAfterCallback = _.bind(this.onAddToCartSuccessAfter, this);
            this.hub.on('cartware_cart/add-after', addToCartAfterCallback);
            this.destructorCallbacks.push(function() {
                self.hub.off('cartware_cart/add-after', addToCartAfterCallback);
            });
        },

        onAddToCartSuccessAfter: function() {
            this.addToCartPopup = BEM.block('cart-add-ajax-popup');
            this.addToCartPopup.addModifier('has-related');
            this.miniCart = BEM.block('mini-cart');
            this.accessoriesBlock = BEM.block('product-list-related');
            this.accessoriesBlock.getElements('add-to-cart-button').on('click', _.bind(this.onAddToCartClick, this));

            // children of related configurables

            this.accessoriesBlock.getElements('show-options-button').on('click', _.bind(function(event) {
                var button = $(event.currentTarget);
                if (button.bemHasModifier('open')) {
                    button.bemRemoveModifier('open');
                } else {
                    button.bemAddModifier('open');
                }

                var list = this.accessoriesBlock
                    .getElements('list')
                    .filter(':modifier(level-2)')
                    .filter('[data-product-id=' + button.attr('data-product-id') + ']');

                if (list.bemHasModifier('open')) {
                    list.bemRemoveModifier('open');
                } else {
                    list.bemAddModifier('open');
                }
            }, this));
        },

        onAddToCartClick: function(event) {
            var self = this;
            var button = $(event.currentTarget);

            if (button.bemHasModifier('disabled')) {
                return;
            }

            var data = {
                product: button.data('product-id'),
                form_key: document.getElementsByName('form_key')[0] ? document.getElementsByName('form_key')[0].value : null
            };

            var url = button.data('url');

            /*
            if (url.indexOf('isAjax=1') === -1) {
                url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
            }
            */

            // Spinner.add(this.accessoriesBlock);

            button.bemAddModifier('loading');
            button.button('loading');

            $.ajax(url, {
                data: data,
                method: 'POST'
            }).always(function() {
                button.button('reset');
                // Spinner.remove();
            }).then(_.bind(function(response) {
                if (typeof response === 'string') {
                    alert(response);
                } else {
                    if (response.success === true) {
                        button.bemAddModifier('disabled');
                        if ('mini_cart' in response) {
                            self.miniCart.replaceWith(response.mini_cart);
                            self.miniCart = BEM.block('mini-cart');
                        }
                    } else {
                        if ('message' in response) {
                            alert(response.message);
                        }
                    }
                }
                button.bemRemoveModifier('loading');
            }), this);
        },

        destructor: function() {
            _.forEach(this.destructorCallbacks, function(fn) { fn.call(this); }, this);
            this.destructorCallbacks = [];
        }
    });
});
